<template>
  <div class="modal fade" :id="name" tabindex="-1" role="dialog" :aria-labelledby="name" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title" id="forgot_ModalLabel"><i class="fa fa-clock-o mr-5"></i>Bestellhistorie</h4>
        </div>
        <div class="modal-body">
          <ul class="list-group list-group-unbordered">
            <template v-for="t in transitions">
              <li v-for="e in t.transitions" class="list-group-item">
                <p><strong>{{t.date}}</strong><span class="text-muted small ml-5"><i class="fa fa-clock-o"></i> {{e.time}}</span><br>
                  <i :class="[getClass(e.event).icon, getClass(e.event).style, 'mr-5']"></i><span :class="getClass(e.event).style">{{e.event === 'cancelled' ? 'cancelled_line' : e.event === 'mp_cancellation' ? 'mp_cancellation_line' : e.event | translate }}</span>
                </p>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['transitions', 'main', 'name'],
  data () {
    return {
      show: true
    }
  },
  methods: {
    getClass (e) {
      e = e === 'mp_cancellation_tr' || e === 'mp_cancellation_ln' || e === 'mp_cancellation' ? 'mp_cancellation' : e.split('_')[0]
      switch (e) {
        case 'shipped':
          return {icon: 'fa fa-truck', style: 'text-success'}
        case 'initial':
          return {icon: 'fa fa-cloud-download', style: 'text-primary'}
        case 'approved':
          return {icon: 'fa fa-thumbs-up', style: 'text-info'}
        case 'fulfilled':
          return {icon: 'fa fa-check', style: 'text-teal'}
        case 'cancelled':
          return {icon: 'fa fa-ban', style: 'text-danger'}
        case 'mp_cancellation':
          return {icon: 'fa fa-ban', style: 'text-danger'}
        case 'returned':
          return {icon: 'fa fa-reply', style: 'text-warning'}
        case 'open':
          return {icon: 'fa fa-thumbs-up', style: 'text-info'}
      }
    }
  },
  watch: {
    transitions () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/OrderHistory.vue